import { FSMCommonTransitions } from '../../../../../FSM/shared/constants'

const FSMTransitionsFNOLVehicleSE = {
  ...FSMCommonTransitions,
  FLOW_MACHINE_ID: 'FNOLFlowMachineVehicleSE',
}

export { FSMTransitionsFNOLVehicleSE }
